import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#888",
      d: "M0 20c0 11.046 8.954 20 20 20s20-8.954 20-20S31.046 0 20 0 0 8.954 0 20Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M31 13.25c0-1.238-.99-2.25-2.2-2.25H11.2C9.99 11 9 12.012 9 13.25v13.5c0 1.238.99 2.25 2.2 2.25h17.6c1.21 0 2.2-1.012 2.2-2.25v-13.5Zm-2.2 0L20 18.875l-8.8-5.625h17.6Zm0 13.5H11.2V15.5l8.8 5.625 8.8-5.625v11.25Z"
    }, null, -1)
  ]))]))
}
export default { render: render }